<div class="battery-container">
  <div class="calories" *ngIf="dataIsReady">
    <p class="calori">{{ calorie.toFixed(0) }}</p>
    <p class="title">کالری جذب شده</p>
  </div>
  <div *ngIf="dataIsReady" class="battery-chart-holder" id="battery-chart">
    <div class="battery-chart-background"></div>
    <div style="z-index: 11">
      <canvas
        baseChart
        id="canvas"
        [data]="demodoughnutChartData"
        [labels]="doughnutChartLabels"
        [colors]="chartColors"
        height="150"
        width="150"
        [chartType]="doughnutChartType"
        [options]="options"
        id="canvass"
      >
      </canvas>
      <img
        class="battery-chart-calorie-icon"
        src="assets/general/calorie.png"
      />
      <div
        *ngIf="chartIndicatorNumber - calorie >= 0"
        class="battery-chart-title"
      >
        {{ (chartIndicatorNumber - calorie).toFixed(0) }}
      </div>
      <div
        *ngIf="chartIndicatorNumber - calorie < 0 && status === 'cheatDay'"
        class="battery-chart-title"
      >
        0
      </div>
      <div
        *ngIf="chartIndicatorNumber - calorie < 0 && status !== 'cheatDay'"
        class="battery-chart-title"
        style="color: #e65e50"
      >
        {{ (calorie - chartIndicatorNumber).toFixed(0) }}-
      </div>
      <div
        *ngIf="chartIndicatorNumber - calorie >= 0 || status === 'cheatDay'"
        class="battery-chart-description"
      >
        کالری باقیمانده
      </div>
      <div
        *ngIf="chartIndicatorNumber - calorie < 0 && status !== 'cheatDay'"
        class="battery-chart-description"
        style="color: #e65e50"
      >
        کالری
      </div>
      <img
        *ngIf="status === 'diet'"
        class="battery-chart-indicator"
        src="assets/plan/chartIndicator.svg"
      />
    </div>
  </div>
  <div class="exercise" *ngIf="dataIsReady">
    <p class="calori">{{ exerciseCalories.toFixed(0) }}</p>
    <p class="title">کالری سوزانده شده</p>
  </div>
  <div
    *ngIf="dataIsReady"
    class="battery-chart-fake"
    (click)="goToDailyFoodFact()"
  ></div>
  <!-- <ngx-skeleton-loader
    [theme]="{
      height: '22px',
      width: '78px',
      'background-color': '#e8eaef',
      position: 'absolute',
      right: '16px',
      top: '50%',
      transform: 'translateY(-50%)'
    }"
  ></ngx-skeleton-loader> -->

  <ngx-skeleton-loader
    *ngIf="!dataIsReady"
    appearance="circle"
    [theme]="{
      top: '10px',
      right: 'calc( 50% - 70px )',
      height: '140px',
      width: '140px',
      position: 'absolute',
      border: '2px solid rgb(232, 234, 239)',
      'background-color': 'white',
      margin: '0'
    }"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
    *ngIf="!dataIsReady"
    appearance="circle"
    [theme]="{
      top: '20px',
      right: 'calc( 50% - 60px )',
      height: '120px',
      width: '120px',
      position: 'absolute',
      'background-color': '#e8eaef',
      margin: '0'
    }"
  ></ngx-skeleton-loader>
</div>
